import axios from "axios";

import Swal from "sweetalert2";

export const getLeavesEmployee = async () => {
  try {
    const response = await axios.get(`/employee-leave`);
    console.log("Leave Employee Fetched..", response.data.data);
    return response.data.data;
  } catch (error) {
    console.log("Error fetching Leave Employees", error.message);
    throw error;
  }
};

export const getSingleLeaveEmployee = async (id) => {
  try {
    const response = await axios.get(`/employee-leave/${id}`);
    return response.data.data;
  } catch (error) {
    console.log("Error fetching Single Leave Employees", error.message);
    throw error;
  }
};

export const createLeaveEmployee = async (leaveData, documentFile) => {
  try {
    const formData = new FormData();
    for (const key in leaveData) {
      if (Array.isArray(leaveData[key])) {
        formData.append(key, JSON.stringify(leaveData[key]));
      } else {
        formData.append(key, leaveData[key]);
      }
    }
    if (documentFile) {
      formData.append("document", documentFile);
    }

    console.log("leaveData object:", leaveData); // Added log
    console.log("FormData entries:");
    for (const [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    const response = await axios.post("/employee-leave", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to create employee leave:", error.message, error.response?.data);
    throw error;
  }
};


export const createAdminMaternityLeave = async (leaveData, documentFile) => {
  try {
    const formData = new FormData();
    formData.append("employeeId", leaveData.employeeId);
    formData.append("adminUserId", leaveData.adminUserId);
    formData.append("expectedDeliveryDate", leaveData.expectedDeliveryDate);
    formData.append("startDate", leaveData.startDate);
    formData.append("endDate", leaveData.endDate);
    formData.append("reason", leaveData.reason);
    formData.append("leaveDays", JSON.stringify(leaveData.leaveDays));

    if (documentFile) {
      formData.append("document", documentFile); // Match backend Multer field name
    }

    const response = await axios.post(`/employee-leave/admin/maternity-leave`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`, // Adjust if token is stored differently
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating maternity leave:", error);
    throw error;
  }
};



export const updateLeaveEmployee = async (id, leaveDetails) => {
  try {
    const response = await axios.put(`/employee-leave/${id}`, leaveDetails);
    return response.data;
  } catch (error) {
    console.error("Failed to Update employee leave:", error.message);
    throw error;
  }
};

export const updateShortLeave  = async (id, leaveDetails) => {
  try {
    const response = await axios.put(`/employee-leave/short-leave/${id}`, leaveDetails);
    return response.data;
  } catch (error) {
    console.error("Failed to Update employee leave:", error.message);
    throw error;
  }
};

export const updateDutyLeave = async (id, leaveDetails, documentFile) => {
  try {
    const formData = new FormData();
    formData.append('leaveDetails', JSON.stringify(leaveDetails));
    if (documentFile) {
      formData.append('document', documentFile);
    }

    console.log('Sending updateDutyLeave request:', {
      id,
      leaveDetails,
      hasDocument: !!documentFile,
      endpoint: `/api/employee-leave/duty-leave/${id}`,
    });

    const response = await axios.put(`employee-leave/duty-leave/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    console.log('updateDutyLeave response:', response.data);

    if (!response.data) {
      throw new Error('Empty response data from server');
    }

    return response.data;
  } catch (error) {
    console.error('Error in updateDutyLeave:', {
      error: error.message,
      response: error.response?.data,
      status: error.response?.status,
      id,
      leaveDetails,
    });
    throw error;
  }
};


export const updateSpecialLeave   = async (id, leaveDetails) => {
  try {
    const response = await axios.put(`/employee-leave/special-leave/${id}`, leaveDetails);
    return response.data;
  } catch (error) {
    console.error("Failed to Update employee leave:", error.message);
    throw error;
  }
};

export const updateMaternityLeave    = async (id, leaveDetails) => {
  try {
    const response = await axios.put(`/employee-leave/maternity-leave/${id}`, leaveDetails);
    return response.data;
  } catch (error) {
    console.error("Failed to Update employee leave:", error.message);
    throw error;
  }
};

export const deleteLeaveEmployee = async (id) => {
  if (!id) {
    throw new Error("Invalid or missing leave ID");
  }
  try {
    const response = await axios.delete(`/employee-leave/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to Delete employee leave:", error.message);
    throw error;
  }
};

export const deleteShortLeave = async (id) => {
  try {
    const response = await axios.delete(`/employee-leave/short-leave/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteDutyLeave = async (id) => {
  try {
    const response = await axios.delete(`/employee-leave/duty-leave/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteSpecialLeave = async (id) => {
  try {
    const response = await axios.delete(`/employee-leave/special-leave/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteMaternityLeave = async (id) => {
  try {
    const response = await axios.delete(`/employee-leave/maternity-leave/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const fetchLeaveTypeAndCount = async (id) => {
  try {
    const response = await axios.get(`/allocate-leave-user/${id}`);
    console.log("response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Failed fetching leave allocation data:", error.message);
    throw error;
  }
};

export const updateApprovalStatus = async (id, approval) => {
    try {
        console.log('Sending request to update approval status:', { id, approval });
        const response = await axios.put(`/employee-leave/approval/${id}`, {
            approval,
        });
        console.log('Response:', response.data);
        return response.data.data;
    } catch (error) {
        console.error('Error updating approval status:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            headers: error.response?.headers,
        });
      const errorMessage = error.response?.data?.message || 'Failed to update approval status';
Swal.fire({
  title: 'Cannot Approve Leave',
  text: `${errorMessage}. Please check the employee's leave allocation or adjust the leave request.`,
  icon: 'error',
  showCancelButton: true,
  cancelButtonText: 'Close',
}).then((result) => {
  if (result.isConfirmed) {
console.log(result.isConfirmed)  }
});
    }
};

export const getEmployeeLeaveWithEmployee = async (userId, setLoading) => {
  try {
    setLoading(true);
    const response = await axios.get(`/employee-leave`, {
      params: { userId },
      headers: { "Cache-Control": "no-cache" },
    });
    setLoading(false);
    return response.data;
  } catch (error) {
    setLoading(false);
    console.error("Error fetching employee leaves:", error.message);
    throw error;
  }
};

export const getSearchResults = async ({
  name,
  epf_number,
  startDate,
  endDate,
  leaveType,
  branch,
  setLoading,
  userId,
  status,
}) => {
  try {
    setLoading(true);
    const response = await axios.get(`/search-leaves`, {
      params: {
        name,
        epf_number,
        startDate,
        endDate,
        leaveType,
        branch,
        userId,
        status,
      },
      headers: { "Cache-Control": "no-cache" },
    });
    setLoading(false);
    console.log(response, "This is Response");
    return response.data.data;
  } catch (error) {
    setLoading(false);
    throw error;
  }
};

export const getUserLeaves = async (userId) => {
  try {
    const response = await axios.get(`/user-leaves/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching allocated leaves:", error.response?.data || error.message);
    throw error;
  }
};

export const getShortLeaves = async (userId) => {
  try {
    const response = await axios.get(`/employee-leave/short-leaves/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching short leaves:", error.response?.data || error.message);
    throw error;
  }
};
export const getMaternityLeaves = async (userId) => {
  try {
    const response = await axios.get(`/employee-leave/maternity-leaves/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching short leaves:", error.response?.data || error.message);
    throw error;
  }
};
export const getDutyLeaves = async (userId) => {
  try {
    const response = await axios.get(`/employee-leave/duty-leaves/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching duty leaves:", error.response?.data || error.message);
    throw error;
  }
};

export const getSpecialLeaves = async (userId) => {
  try {
    const response = await axios.get(`/employee-leave/special-leaves/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching special leaves:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchShortLeaves = async (userId) => {
  try {
    const response = await axios.get(`/employee-leave/short-leaves/admin/${userId}`);
    console.log("Short Leaves Data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching short leaves:", error.response?.data || error.message);
    return null;
  }
};

export const fetchDutyLeaves = async (userId) => {
  try {
    const response = await axios.get(`/employee-leave/duty-leaves/admin/${userId}`);
    console.log("Duty Leaves Data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching duty leaves:", error.response?.data || error.message);
    return null;
  }
};

export const fetchMaternityLeaves = async (userId) => {
  try {
    const response = await axios.get(`/employee-leave/maternity-leaves/admin/${userId}`);
    console.log("Duty Leaves Data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching duty leaves:", error.response?.data || error.message);
    return null;
  }
};

export const fetchSpecialLeaves = async (userId) => {
  try {
    const response = await axios.get(`/employee-leave/special-leaves/admin/${userId}`);
    console.log("Special Leaves Data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching special leaves:", error.response?.data || error.message);
    return null;
  }
};

export const updateApproval = async (id, approvalStatus) => {
  try {
    const response = await axios.put(`/employee-leave/duty-leaves/update-approval/${id}`, {
      approval: approvalStatus,
    });
    console.log("Approval updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating approval:", error.response?.data || error.message);
    throw error;
  }
};

export const updateSpecialApproval = async (id, approvalStatus) => {
  try {
    const response = await axios.put(`/employee-leave/special-leaves/update-approval/${id}`, {
      approval: approvalStatus,
    });
    console.log("Approval updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating approval:", error.response?.data || error.message);
    throw error;
  }
};
export const updateShortApproval = async (id, approvalStatus) => {
  try {
    const response = await axios.put(`/employee-leave/short-leaves/update-approval/${id}`, {
      approval: approvalStatus,
    });
    console.log("Approval updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating approval:", error.response?.data || error.message);
    throw error;
  }
};
export const updateMaternityApprovalById = async (id, approvalStatus) => {
  try {
    const response = await axios.put(`/employee-leave/maternity-leaves/update-approval/${id}`, {
      approval: approvalStatus,
    });
    console.log("Approval updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating approval:", error.response?.data || error.message);
    throw error;
  }
};

export const searchShortLeaves = async ({
  name,
  epf_number,
  startDate,
  endDate,
  branch,
  setLoading1,
  userId,
  status,
}) => {
  try {
    setLoading1(true);
    const response = await axios.get(`/search-short-leaves`, {
      params: {
        name,
        epf_number,
        startDate,
        endDate,
        branch,
        userId,
        status,
      },
      headers: { "Cache-Control": "no-cache" },
    });
    setLoading1(false);
    console.log(response, "This is Response");
    return response.data.data;
  } catch (error) {
    setLoading1(false);
    throw error;
  }
};

export const searchDutyLeaves = async ({
  name,
  epf_number,
  startDate,
  endDate,
  branch,
  setLoading2,
  userId,
  status,
}) => {
  try {
    setLoading2(true);
    const response = await axios.get(`/search-duty-leaves`, {
      params: {
        name,
        epf_number,
        startDate,
        endDate,
        branch,
        userId,
        status,
      },
      headers: { "Cache-Control": "no-cache" },
    });
    setLoading2(false);
    console.log(response, "This is Response");
    return response.data.data;
  } catch (error) {
    setLoading2(false);
    throw error;
  }
};

export const searchMaternityLeaves = async ({
  name,
  epf_number,
  startDate,
  endDate,
  branch,
  setLoading4,
  userId,
  status,
}) => {
  try {
    setLoading4(true);
    const response = await axios.get(`/search-maternity-leaves`, {
      params: {
        name,
        epf_number,
        startDate,
        endDate,
        branch,
        userId,
        status,
      },
      headers: { "Cache-Control": "no-cache" },
    });
    setLoading4(false);
    console.log(response, "This is Response");
    return response.data.data;
  } catch (error) {
    setLoading4(false);
    throw error;
  }
};

export const searchSpecialLeaves = async ({
  name,
  epf_number,
  startDate,
  endDate,
  branch,
  setLoading3,
  userId,
  status,
}) => {
  try {
    setLoading3(true);
    const response = await axios.get(`/search-special-leaves`, {
      params: {
        name,
        epf_number,
        startDate,
        endDate,
        branch,
        userId,
        status,
      },
      headers: { "Cache-Control": "no-cache" },
    });
    setLoading3(false);
    console.log(response, "This is Response");
    return response.data.data;
  } catch (error) {
    setLoading3(false);
    throw error;
  }
};

export const getCoverupRequests = async (userId) => {
  try {
    console.log("Fetching coverup requests for user:", userId);
    const response = await axios.get(`/employee-leave/coverup-requests/${userId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching coverup requests:", error.response?.data || error.message);
    throw error;
  }
};

export const respondToCoverupRequest = async (leaveId, response, userId, rejectionReason = "") => {
  try {
    const apiResponse = await axios.post(
      `/employee-leave/respond-to-coverup`,
      {
        leaveId,
        response: response === "APPROVED" ? "ACCEPTED" : response,
        responderId: userId,
        rejectionReason,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );
    return apiResponse.data;
  } catch (error) {
    const errorMsg = error.response?.data?.message || "Failed to respond to coverup request";
    console.error("respondToCoverupRequest error:", errorMsg, error.response?.data);
    throw new Error(errorMsg);
  }
};

export const getMyCoverupNeededLeaves = async (userId) => {
  try {
    const response = await axios.get(
      `/employee-leave/my-coverup-leaves/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.message || "Failed to fetch my coverup-needed leaves";
    console.error("getMyCoverupNeededLeaves error:", errorMsg);
    throw new Error(errorMsg);
  }
};

export const getMyLeaveStatus = async (userId) => {
  try {
    const response = await axios.get(
      `/employee-leave/my-leave-status/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.message || "Failed to fetch my leave status";
    console.error("getMyLeaveStatus error:", errorMsg);
    throw new Error(errorMsg);
  }
};



export const getLeaveNotifications = async (userId) => {
  try {
    console.log(`Fetching notifications for userId: ${userId}`);
    const response = await axios.get(`/employee-leave/notifications/${userId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
    });
    console.log("API response:", response.data);
    return response.data.data || []; // Return empty array if data is undefined
  } catch (error) {
    console.error("Error fetching leave notifications:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
        console.error("Failed to fetch notifications:", error);
  }
};


export const adjustMaternityLeaveDatesCustom = async (leaveId, payload) => {
  try {
    const response = await axios.put(`/employee-leave/maternity-leaves/adjust-dates/${leaveId}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error adjusting maternity leave dates:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};



export const getSecondLevelSpecialLeaves = async () => {
  try {
    const response = await axios.get(`/employee-leave/special-leaves/second-level`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error.response?.data?.message || "Failed to fetch second-level special leaves");
  }
};


// Search second-level special leaves
export const searchSecondLevelSpecialLeaves = async (params) => {
  try {
    console.log("Sending search request with params:", params);
    const response = await axios.get(`/employee-leave/special-leaves/second-level/search`, {
      params,
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to search second-level special leaves";
    console.error("Search error:", errorMessage, error);
    throw new Error(errorMessage);
  }
};

// Update second-level approval status
export const updateSecondLevelApproval = async (id, secondLevelApproval) => {
  try {
    const response = await axios.put(
      `/employee-leave/special-leaves/second-level-approval/${id}`,
      { secondLevelApproval },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update second-level approval");
  }
};



export const createAdminAuthorizedNoPayLeave = async (leaveData) => {
  try {
    const response = await axios.post(`/employee-leave/admin/no-pay-leave`, leaveData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating Authorized No Pay Leave:", error);
    throw error;
  }
};

export const searchAuthorizedNoPayLeaves = async (params) => {
  try {
    const response = await axios.get('/employee-leave/admin/no-pay-leaves/search', {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    console.log("API Response:", response.data); // Log response for debugging
    return response.data;
  } catch (error) {
    console.error("Error searching Authorized No Pay Leaves:", error.response?.data || error.message);
    throw error;
  }
};

// New function to update Authorized No Pay Leave approval
export const updateAuthorizedNoPayApproval = async (leaveId, approvalStatus) => {
  try {
    const response = await axios.patch(
      `/employee-leave/admin/no-pay-leaves/${leaveId}/approval`,
      { approval: approvalStatus },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating Authorized No Pay Leave approval:", error);
    throw error;
  }
};
